module.exports = __webpack_public_path__ + "static/GMDEA_cover-9fc29ad30dbf0989bef9543c6d763128.png";